import gql from 'graphql-tag';

export default gql`
  mutation removeSectionContent($id: UUID!) {
    removeSectionContent(_id: $id)
  }
`;
